// extracted by mini-css-extract-plugin
export default {"CSRPOtentialIssueMessage":"CSRPOtentialIssueMessage_vk5xKjjR","CSRPotentialIssuemodalTextPassage":"CSRPotentialIssuemodalTextPassage_XfcxInzs"};